import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { map } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { Page } from '../model/Page';
import { Observable, BehaviorSubject } from 'rxjs';
import { PollDTO } from '../model/PollDTO';
import { EnumDTO } from '../model/EnumDTO';
import { ThemeSettingsService } from 'src/app/_layout/settings/theme-settings.service';

@Injectable({
    providedIn: 'root'
})
export class MenuService {

    private showMenu = new BehaviorSubject(true);
    sharedShowMenu = this.showMenu.asObservable();

    private reloadData = new BehaviorSubject(false);
    sharedReloadData = this.reloadData.asObservable();

    constructor() { }

    nextMessage(showMenu: boolean) {
        this.showMenu.next(showMenu);
    }

    nextReloadData(reloadData: boolean) {
        this.reloadData.next(reloadData);
    }

}
